import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { IRestrictedUsernamesService } from "@shared/interfaces/restricted-usernames-service.interface";
import { CreateRestrictedUsernameDto, RestrictedUsernameDto } from "@shared/types/restricted-usernames/restricted-usernames.dto";

@appInjectable()
export class RestrictedUsernamesService extends BaseService implements IRestrictedUsernamesService {
    
    private configService = appInject<IConfigService>(DI_TOKENS.configService);
    private httpClient = appInject<IHttpClientService>(
        DI_TOKENS.httpClientService,
    );
    private baseURL: string;

    constructor() {
        super();
        this.baseURL = this.configService.baseUrl;
    }

    create: IRestrictedUsernamesService["create"] = async (dto: CreateRestrictedUsernameDto) => {
        const { data } = await this.httpClient.post<RestrictedUsernameDto[]>(
            "/restricted-usernames",
            {
                ...dto,
            },
            {
                baseURL: this.baseURL,
            },
        );

        return data;
    }

    update: IRestrictedUsernamesService["update"] = async (dto) => {
        const { data } = await this.httpClient.patch<RestrictedUsernameDto>(
            `/restricted-usernames/${dto.id}`,
            {
                ...dto,
            },
            {
                baseURL: this.baseURL,
            },
        );

        return data;
    }

    list: IRestrictedUsernamesService["list"] = async (dto) => {
        const { data } = await this.httpClient.get<ReturnType<IRestrictedUsernamesService["list"]>>("/restricted-usernames", {
            params: dto,
            baseURL: this.baseURL,
        });

        return data;
    }

    delete: IRestrictedUsernamesService["delete"] = async (id) => {
        const { data } = await this.httpClient.delete<ReturnType<IRestrictedUsernamesService["delete"]>>(`/restricted-usernames/${id}`, {
            baseURL: this.baseURL,
        });
        return data;
    }
}
